import RegionsForm from './RegionsForm';

export default RegionsForm;
